<template lang="html">
  <div class="floorplan-info-short">
    <div>
      <!-- Beds -->
      <span class="beds">
        <span v-if="floorplan.beds > 0">
          <span class="emphasize">{{ floorplan.beds }}</span>
          <span>b</span>
          <span v-if="floorplan.dens > 0">+ den</span>
        </span>
        <span class="studio emphasize" v-if="floorplan.beds < 1">studio</span>
      </span>
      <span class="px-1">.</span>
      <!-- Baths -->
      <span class="baths">
        <span class="emphasize">{{ floorplan.baths }}</span>
        <span> bath<span v-if="floorplan.baths > 1">s</span></span>
      </span>
    </div>
    <div class="sizes">
      <!-- Interior -->
      <span class="interior">
        <span class="emphasize">{{ floorplan.interior }}</span>
        <span>sqft</span>
      </span>
      <span class="px-1">&bull;</span>
      <!-- Exposure -->
      <span class="exposure emphasize">
        <span>{{ floorplan.exposure.join(', ').toUpperCase() }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'floorplan-info-shortt',
  props: {
    floorplan: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.floorplan-info-short {
  color: black;
  line-height: 1.5rem;
  font-size: 0.8rem;
}

.studio, .exposure {
  text-transform: uppercase;
}

.beds, .baths {
  font-family: Scandia-Bold, sans-serif;
  font-size: 1.1rem;
}

.emphasize {
  font-family: Scandia-Medium, sans-serif;
  font-size: 1.2rem;
}

.sizes {
  color: var(--text);

  .emphasize {
    font-family: Scandia-Regular, sans-serif;
    font-size: 1.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanInfoShort.vue